(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-vd-artist-slot]').forEach((slot) => {
      if (slot.dataset.rotationReady) return;
      slot.dataset.rotationReady = 'true';
      const choices = [...slot.querySelectorAll('template')];
      if (!choices.length) return;
      const key = `vd-artist-pick:${slot.dataset.vdArtistSlot}`;
      let previous = -1;
      try { previous = Number(sessionStorage.getItem(key) ?? -1); } catch {}
      let index = Math.floor(Math.random() * choices.length);
      if (choices.length > 1 && index === previous) index = (index + 1) % choices.length;
      const card = choices[index].content.firstElementChild.cloneNode(true);
      slot.querySelector(':scope > article')?.replaceWith(card);
      try { sessionStorage.setItem(key, String(index)); } catch {}
      choices.forEach((choice) => choice.remove());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
